import { deviceType } from '@/utils/common'
import Index from '../common/consent/index.vue'
import PCConsent from './pc/consent/index.vue'
import MobileConsent from './mobile/consent/index.vue'

export const PersonalHomeConsentRoute = {
  path: '/recruiting/personal/consent',
  component: deviceType.isPc ? PCConsent : MobileConsent,
  meta: {
    noAuth: true,
    isAllInclude: true,
    titleI18nKey: 'personal.menu.policy',
    mobileHomeMenu: {
      iconClass: 'icona-PrivacyPolicy',
      nameI18nKey: 'personal.consent.homeMenu.name',
      descI18nKey: 'personal.consent.homeMenu.desc'
    },
    rootLayout: {
      hiddenPageMenu: true,
      hiddenPageHeader: true
    }
  }
}

export default {
  path: '/recruiting/consent',
  component: Index,
  meta: {
    noAuth: true,
    isAllInclude: true,
    titleI18nKey: 'personal.consent.homeMenu.name',
    mobileHomeMenu: {
      redirectPath: '/recruiting/consent',
      iconClass: 'icona-PrivacyPolicy',
      nameI18nKey: 'personal.consent.homeMenu.name',
      descI18nKey: 'personal.consent.homeMenu.desc'
    }
  }
}
